/** Backend middleware expects Bearer {sessionId}&{organizationId}, same as updateScore. */
function backendBearerCredential(sessionId, organizationId, token) {
  const t = typeof token === 'string' ? token.trim() : '';
  if (t.includes('&')) return t;
  const sid = String(sessionId || '').trim();
  const oid = String(organizationId || '').trim();
  return `${sid}&${oid}`;
}

export async function fetchReport({
  sessionId,
  organizationId,
  userId,
  token,
  gameMode,
}) {
  const bearer = backendBearerCredential(sessionId, organizationId, token);
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/fetchReport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearer}`,
    },
    body: JSON.stringify({
      userId,
      ...(gameMode != null && String(gameMode).trim() !== ''
        ? { gameMode: String(gameMode).trim() }
        : {}),
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || 'Failed to fetch report');
  }
  return data;
}
